import Container from 'react-bootstrap/Container';

export default function Body({ children }) {
    return (
        <Container fluid className='Body'>
            { children }
        </Container>
    )
}